module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-kpito-bottom-01.2@2x.9a3084f3.jpg";